import React from 'react';

import Accordion from 'src/components/elements/Accordion';

import styles from './FAQ.scss';

type Props = {
  data: Array<{
    id: number;
    title: string;
    content: string;
  }>;
};

const FAQ = ({ data }: Props) => (
  <div id="faq" className={styles.faq}>
    <div className={styles.faqTitle}>FAQ</div>
    <Accordion data={data} />
  </div>
);

export default FAQ;
